import type { NewsArticle } from '@/content/news/articles'
import { toAbsoluteUrl } from '@/lib/pelgo-seo'

type NewsArticleJsonLdProps = {
  article: NewsArticle
  canonicalPath: string
}

function parseAuthorName(byline: string): string {
  return byline.replace(/^By\s+/i, '').trim()
}

export function NewsArticleJsonLd({ article, canonicalPath }: NewsArticleJsonLdProps) {
  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'NewsArticle',
    headline: article.title,
    description: article.summary,
    image: [toAbsoluteUrl(article.heroImageSrc)],
    datePublished: article.publishedAt,
    author: {
      '@type': 'Person',
      name: parseAuthorName(article.author),
    },
    publisher: {
      '@type': 'Organization',
      name: 'Pelgo',
      logo: {
        '@type': 'ImageObject',
        url: toAbsoluteUrl('/logo-black.png'),
      },
    },
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': toAbsoluteUrl(canonicalPath),
    },
    url: toAbsoluteUrl(canonicalPath),
    ...(article.publicationSeries
      ? {
          isPartOf: {
            '@type': 'CreativeWorkSeries',
            name: article.publicationSeries,
          },
        }
      : {}),
  }

  return (
    <script
      type="application/ld+json"
      // biome-ignore lint/security/noDangerouslySetInnerHtml: JSON-LD requires inline script
      dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
    />
  )
}
